import React from 'react';
import { connect } from 'dva';
import CardInfo from './CardInfo.js';
import CardEnterpriseInfo from './CardEnterpriseInfo';

@connect(({ merchantBusinessMy }) => ({
  cardInfo: merchantBusinessMy.cardInfo,
}))
export default class CardInfoFragment extends React.Component {
  componentDidMount() {
    this.props.dispatch({ type: 'merchantBusinessMy/fetchCardInfo' });
  }

  render() {
    const { cardInfo, labelLayout, contentLayout } = this.props;

    if (cardInfo.type === 0) {
      return <CardInfo labelLayout={labelLayout} contentLayout={contentLayout} />;
    }

    return <CardEnterpriseInfo labelLayout={labelLayout} contentLayout={contentLayout} />;
  }
}



// WEBPACK FOOTER //
// ./src/routes/Merchant/Business/My/Card/CardInfoFragment.js